"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = __importDefault(require("debug"));
var Poller = /** @class */ (function () {
    function Poller(options) {
        this.dispatch = options.dispatch;
        this.name = options.name;
        this.actionCreator = options.actionCreator;
        this.pollerVariables = options.variables;
        this.pollerExtraArgs = options.extraArgs;
        this.isActive = options.isActive || false;
        this.changeActiveState = options.changeActiveState;
        this.debug = debug_1.default("app:poller:" + options.name);
    }
    Poller.prototype.setVariables = function (variables, extraArgs) {
        this.pollerVariables = variables;
        this.pollerExtraArgs = extraArgs;
    };
    Poller.prototype.clearVariables = function () {
        this.pollerVariables = undefined;
        this.pollerExtraArgs = undefined;
    };
    Poller.prototype.requestContent = function (options) {
        if (options === void 0) { options = {
            isRepeat: false,
            isPolling: false,
            isLoadMore: false,
        }; }
        var isRepeat = options.isRepeat, isPolling = options.isPolling, isLoadMore = options.isLoadMore;
        var action = this.actionCreator(this.pollerVariables, __assign({ withLoader: !isRepeat, isPolling: isPolling,
            isLoadMore: isLoadMore }, this.pollerExtraArgs));
        return this.dispatch(action);
    };
    Poller.prototype.enable = function (_a) {
        var _b = _a === void 0 ? {} : _a, skipRequest = _b.skipRequest;
        this.debug('%c enable', 'background-color: lime', this.isActive);
        this.isActive = true;
        if (!skipRequest)
            this.requestContent();
        if (this.changeActiveState) {
            this.changeActiveState();
        }
    };
    Poller.prototype.disable = function () {
        this.debug('%c disable', 'background-color: wheat', this.isActive);
        this.isActive = false;
    };
    return Poller;
}());
exports.default = Poller;
//# sourceMappingURL=Poller.js.map